export default __webpack_public_path__ + "static/media/bike1.c9ebcbf5.jpg";